import { Dialog, DialogContent, DialogTitle, IconButton, Paper, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';

const MOBILE_QUERY = '(max-width:768px)';

const DraggablePaper = props => {
  return (
    <Draggable handle='#draggable-dialog-title' cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
};

const DialogWrapper = ({ open, onHandleCancel, title, children, maxWidth, fullWidth }) => {
  // On phones: full-screen, no drag (drag handle fights with touch scrolling).
  const isMobile = useMediaQuery(MOBILE_QUERY);

  return (
    <Dialog
      sx={{ zIndex: 1000 }}
      open={open}
      onClose={onHandleCancel}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={isMobile}
      PaperComponent={isMobile ? Paper : DraggablePaper}
      className={isMobile ? 'mobile-dialog' : undefined}
      aria-labelledby='draggable-dialog-title'>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 1,
          position: isMobile ? 'sticky' : undefined,
          top: 0,
          zIndex: 1,
          background: isMobile ? '#fff' : undefined,
          fontSize: isMobile ? '17px' : undefined,
        }}
        id='draggable-dialog-title'>
        {title}
        <IconButton onClick={onHandleCancel} color='secondary' aria-label='Close'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={isMobile ? { px: 1.5, overflowX: 'auto' } : undefined}>{children}</DialogContent>
    </Dialog>
  );
};

DialogWrapper.defaultProps = {
  maxWidth: 'md',
  fullWidth: false
};

export default DialogWrapper;
